import React, { useState, useEffect } from "react";
import CustomizableGameIcon from "../Icons/CustomizableGameIcon";
import { IGVariant, TGameOptions } from "../../../types";
import { useTrackContext } from "../../../hooks/useTrackContext";

interface IProps {
  gameTime: string;
  price: number;
  gameName: TGameOptions;
  variant: IGVariant;
}

const CustomizableVariantBlock: React.FC<IProps> = ({ gameTime, price, gameName, variant }) => {
  const {
    vrSelection: {
      gameCustomization,
      selectedGame,
      variantsAndDate: { selectedVariants },
    },
    dispatch,
  } = useTrackContext();

  const [isHovered, setIsHovered] = useState<boolean>(false);
  const [activeBgColor, setActiveBgColor] = useState<boolean>(false);
  const [chooseGame, setChooseGame] = useState<TGameOptions>(() => {
    const foundGame = gameCustomization.find((vGame) => vGame.selectedVariant.id === variant.id);
    return foundGame ? foundGame.selectedGame : selectedGame;
  });

  const isGameAlreadySelected = gameCustomization.some((vGame) => vGame.selectedVariant.id === variant.id);

  const handleCustomization = (xvariant: IGVariant) => {
    setActiveBgColor((prevActiveBgColor) => !prevActiveBgColor);

    if (isGameAlreadySelected) {
      const updatedCustomization = gameCustomization.filter((vGame) => vGame.selectedVariant.id !== xvariant.id);

      dispatch({
        type: "SET_GAME_CUSTOMIZATION_VARIANT_VIRTUAL_REALITY",
        payload: {
          gameCustomization: updatedCustomization,
        },
      });
    } else {
      setChooseGame(selectedGame);
      const newCustomization = [
        ...gameCustomization,
        {
          selectedGame: selectedGame,
          selectedVariant: xvariant,
          isGameCustomized: true,
        },
      ];

      dispatch({
        type: "SET_GAME_CUSTOMIZATION_VARIANT_VIRTUAL_REALITY",
        payload: {
          gameCustomization: newCustomization,
        },
      });
    }
  };

  useEffect(() => {
    dispatch({
      type: "SET_JOINED_VARIANTS_VIRTUAL_REALITY",
      payload: {
        joinCustomizableWithSelectedVariants: [...gameCustomization, ...selectedVariants.map((xv) => xv.variantsSelectedObject)],
      },
    });
    setActiveBgColor(isGameAlreadySelected);
  }, [dispatch, gameCustomization, isGameAlreadySelected, selectedVariants]);

  return (
    <div
      className={`tw-rounded tw-p-[2px] ${
        gameName === "CyberClash" || gameName === "Kitchen Panic" || gameName === "Zombies" ? "hover:tw-cursor-not-allowed" : "hover:tw-bg-[#F609FF]"
      }`}
    >
      <div
        className={`tw-text-white tw-rounded hover:tw-cursor-pointer ${
          gameName === "CyberClash" || gameName === "Kitchen Panic" || gameName === "Zombies" || activeBgColor
            ? "tw-bg-[linear-gradient(300deg,#F908FF_0%,#D32EFE_8.19%,#37CCFB_87.88%,#05FFFA_100%)]"
            : "tw-bg-white"
        }`}
        onClick={() => (gameName === "CyberClash" || gameName === "Kitchen Panic" || gameName === "Zombies" ? console.log("not customizable game") : handleCustomization(variant))}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <div className="tw-flex tw-flex-col">
          <span
            className={`tw-text-xl tw-font-semibold tw-py-3 tw-px-10 tw-text-center ${
              gameName === "CyberClash" || gameName === "Kitchen Panic" || gameName === "Zombies" || activeBgColor ? "tw-text-white" : "tw-text-[#393B41]"
            }`}
          >
            {gameTime}
          </span>
          {gameName === "CyberClash" || gameName === "Kitchen Panic" || gameName === "Zombies" ? (
            <>
              <span className={`tw-text-center tw-w-full tw-text-[12px] tw-font-semibold tw-bg-black tw-bg-opacity-25 tw-py-1`}>
                {gameName ? (gameName === "CyberClash" ? "Cyber Clash" : gameName === "Zombies" ? "Death Squad" : gameName) : ""}
              </span>
            </>
          ) : (
            <>
              {!activeBgColor ? (
                <>
                  <div className="tw-w-full tw-flex tw-flex-row tw-items-center">
                    <span className="tw-rounded-bl tw-bg-[#2F2C2F] tw-px-[10px] tw-py-[5px]">
                      <CustomizableGameIcon />
                    </span>
                    <span className="tw-rounded-br tw-bg-[#555758] tw-py-[4.2px] tw-text-white tw-w-full tw-text-center tw-font-medium tw-text-[12px]">
                      {variant.quantityAvailable} spots left
                    </span>
                  </div>
                </>
              ) : (
                <>
                  <span className={`tw-text-center tw-w-full tw-text-[12px] tw-font-semibold tw-bg-black tw-bg-opacity-25 tw-py-1`}>
                    {isHovered ? (
                      <>${price.toFixed(2)}</>
                    ) : (
                      <>
                        {activeBgColor && chooseGame !== "In-Venue Decision"
                          ? chooseGame === "CyberClash"
                            ? "Cyber Clash"
                            : chooseGame === "Zombies"
                            ? "Death Squad"
                            : chooseGame
                          : ""}
                      </>
                    )}
                  </span>
                </>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default CustomizableVariantBlock;
